import DocumentsNavItem from './DocumentsNavItem';

export default DocumentsNavItem;
